import VuePassword from 'vue-password'

export default {
    extends: VuePassword,
    inheritAttrs: false,
    mounted () { this.syncAccessibility() },
    updated () { this.syncAccessibility() },
    methods: {
        syncAccessibility () {
            const field = this.$refs.input
            if (!field) return
            field.setAttribute('aria-label', this.$attrs['aria-label'] || this.placeholder || 'Password')
            field.setAttribute('autocomplete', this.$attrs.autocomplete || 'new-password')
            Object.keys(this.$attrs).forEach(name => {
                if (/^aria-/.test(name)) field.setAttribute(name, this.$attrs[name])
            })
            const toggle = this.$el.querySelector('.VuePassword__Toggle')
            if (toggle) {
                toggle.setAttribute('role', 'button')
                toggle.setAttribute('tabindex', '0')
                toggle.setAttribute('aria-label', this.type === 'password' ? 'Show password' : 'Hide password')
                toggle.setAttribute('aria-pressed', this.type === 'text' ? 'true' : 'false')
                if (!toggle.onkeydown) {
                    toggle.onkeydown = event => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault()
                            if (!event.repeat) toggle.click()
                        }
                    }
                }
                Array.prototype.forEach.call(toggle.querySelectorAll('svg'), icon => icon.setAttribute('aria-hidden', 'true'))
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/accessibility/Password.js